




















































































import Vue from "vue";
import IframeDialog from "./IframeDialog.vue";
//import UnterschriftPad from "./UnterschriftPad.vue";
export default Vue.extend({
  name: "Unterschrift",
  components: { IframeDialog /*UnterschriftPad*/ },
  props: {
    value: {
      type: String,
      required: false,
      validator: (value) => true,
    },
    autor: String,
    datum: { type: String, required: true },
    name: { type: String, required: true },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    editUnterschrift() {
      this.dialogVisible = true;
    },
    setDialogVisible(visible: boolean) {
      console.log("Visibility: " + visible);
      this.dialogVisible = false;
    },
    signaturePadReady() {
      if (!this.dialogVisible) {
        return;
      }
      console.debug(
        "Signature Pad Ready Event erhalten, setze Unterschrift ins Pad ein:"
      );
      console.debug(this.value);
      (this.$refs.unterschriftFrame as any).sendToIframe({
        command: "replaceSignature",
        data: this.value,
      });
    },
    saveSignature() {
      (this.$refs.unterschriftFrame as any).sendToIframe({
        command: "saveSignature",
      });
    },
    clearSignature() {
      (this.$refs.unterschriftFrame as any).sendToIframe({
        command: "replaceSignature",
      });
    },
    undo() {
      (this.$refs.unterschriftFrame as any).sendToIframe({
        command: "undo",
      });
    },
    standardSignatur() {
      (this.$refs.unterschriftFrame as any).sendToIframe({
        command: "replaceSignature",
        data: "data:image/png;base64,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",
      });
    },
    deleteSignature() {
      this.dialogVisible = false;
      this.$emit("update", undefined);
    },
    updateSignature(signatureData: string) {
      if (this.dialogVisible) {
        this.dialogVisible = false;
        this.$emit("update", signatureData);
      }
    },
  },
});
